import { Outlet, useLocation } from "react-router-dom";
import Footer from "shared/Footer/Footer";
import Header from "components/Header/Header";
import { useAppSelector } from "store/hooks/hooks";
import { selectLiveEvents, selectEventsStatus } from "store/slices/eventsSlice";

const MainLayout = () => {
  const location = useLocation();
  const liveEvents = useAppSelector(selectLiveEvents);
  const eventsStatus = useAppSelector(selectEventsStatus);

  const isProductsPage = location.pathname === "/products";
  const isCuratedKitsPage = location.pathname === "/curated-kits";
  const isToolPage = location.pathname === "/catalog-generation-page" || location.pathname.startsWith("/mockup-generator");
  const showPrompt = !isProductsPage && !isCuratedKitsPage && !isToolPage && liveEvents.length > 0 && eventsStatus === "succeeded";

  return (
    <>
      <Header />
      <div className={`transition-all duration-300 ${showPrompt ? "pt-32 md:pt-28" : "pt-16 md:pt-20"}`}>
        <Outlet />
      </div>
      <Footer />
    </>
  );
};

export default MainLayout;
